import axios from "axios";
import FileSaver from "file-saver";
import * as moment from "moment";

export async function GetRecentTransactionFiles() {
  const response = await axios.get(`/api/v1.0/transaction/`);

  return response.data;
}

export async function UploadTransactionFile(file) {
  let formData = new FormData();
  formData.append(file.name, file);

  const response = await axios.post(`/api/v1.0/transaction/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    },
    validateStatus: function(status) {
      return true;
    }
  });

  if (response.data.status >= 400) {
    throw response.data;
  }

  return response.data;
}

export async function DownloadTransactionFiles(id, fileName) {
  const response = await axios.get(`/api/v1.0/transaction/${id}`, {
    responseType: "blob"
  });

  FileSaver.saveAs(response.data, fileName);
}

export async function PublishTransactions() {
  const response = await axios.put(`/api/v1.0/transaction/publish`);
  return response.data;
}

export async function DownloadTransactionErrorFile(id, fileName) {
  const response = await axios.get(`/api/v1.0/transaction/${id}/error`, {
    responseType: "blob"
  });

  FileSaver.saveAs(response.data, fileName);
}

export async function DownloadTemplate(initials) {
  const response = await axios.get(`/api/v1.0/transaction/template`, {
    responseType: "blob"
  });

  var fileName = `transaction_template_${initials}_${moment().format(
    "YYYYMMDD"
  )}.xlsx`;
  FileSaver.saveAs(response.data, fileName);
}
